import debug from 'debug';

export const logger = (key: string) => debug(`asuntoarvio:${key}`);
